module.exports = __webpack_public_path__ + "static/img/adv_icon4.37717b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon4.png
// module id = 04si
// module chunks = 1